import {
  LeafIcon,
  AppleIcon,
  FishIcon,
  PackageIcon,
  MapPinIcon,
  MapIcon,
  LandmarkIcon,
  GlobeIcon,
  BuildingOfficeIcon,
  ShipIcon,
  AnchorIcon,
} from '../components/icons';
import { normalizeDestinationKey } from './destinations';

const sectorRules = [
  { match: /banano/i, icon: LeafIcon, accent: 'bg-lime-50 text-lime-600', chip: 'Agroexportación' },
  { match: /mango/i, icon: AppleIcon, accent: 'bg-amber-50 text-amber-600', chip: 'Frutícola' },
  { match: /pescado|mar|camaron|at[uú]n/i, icon: FishIcon, accent: 'bg-sky-50 text-sky-600', chip: 'Acuícola' },
];

const destinationRules = [
  { match: /estados unidos|usa|ee\.?uu\.?/i, icon: BuildingOfficeIcon, accent: 'bg-blue-50 text-blue-600', chip: 'Norteamérica' },
  { match: /mexico|canada/i, icon: BuildingOfficeIcon, accent: 'bg-blue-50 text-blue-600', chip: 'Norteamérica' },
  { match: /asia/i, icon: GlobeIcon, accent: 'bg-emerald-50 text-emerald-600', chip: 'Asia' },
  { match: /centroamerica/i, icon: MapPinIcon, accent: 'bg-orange-50 text-orange-600', chip: 'Latam norte' },
  { match: /caribe/i, icon: MapPinIcon, accent: 'bg-cyan-50 text-cyan-600', chip: 'Caribe' },
  { match: /medio oriente/i, icon: GlobeIcon, accent: 'bg-amber-50 text-amber-600', chip: 'Golfo' },
  { match: /cono sur|sur/i, icon: MapIcon, accent: 'bg-rose-50 text-rose-600', chip: 'Latam sur' },
  { match: /europa/i, icon: LandmarkIcon, accent: 'bg-violet-50 text-violet-600', chip: 'Europa' },
  { match: /africa/i, icon: GlobeIcon, accent: 'bg-lime-50 text-lime-600', chip: 'África' },
  { match: /oceania/i, icon: MapIcon, accent: 'bg-teal-50 text-teal-600', chip: 'Oceanía' },
];

const portRules = [
  { match: /dp world/i, icon: AnchorIcon, accent: 'bg-sky-50 text-sky-600', chip: 'Posorja' },
  { match: /contecon/i, icon: AnchorIcon, accent: 'bg-indigo-50 text-indigo-600', chip: 'Guayaquil' },
  { match: /terminal portuario guayaquil/i, icon: AnchorIcon, accent: 'bg-rose-50 text-rose-600', chip: 'Guayaquil' },
  { match: /yilport/i, icon: AnchorIcon, accent: 'bg-emerald-50 text-emerald-600', chip: 'Puerto Bolívar' },
  { match: /naportec/i, icon: AnchorIcon, accent: 'bg-amber-50 text-amber-600', chip: 'Esmeraldas' },
];

const defaultSectorVisual = { icon: PackageIcon, accent: 'bg-slate-100 text-slate-500', chip: 'Multisectorial' };
const defaultDestinationVisual = { icon: ShipIcon, accent: 'bg-slate-100 text-slate-500', chip: 'Global' };
const defaultPortVisual = { icon: AnchorIcon, accent: 'bg-slate-100 text-slate-500', chip: 'Nacional' };

export const getSectorVisual = (label = 'Otros') => {
  const normalized = label.toLowerCase();
  const match = sectorRules.find((rule) => rule.match.test(normalized));
  return match || defaultSectorVisual;
};

export const getDestinationVisual = (label = 'Otros') => {
  const normalized = normalizeDestinationKey(label);
  const match = destinationRules.find((rule) => rule.match.test(normalized));
  return match || defaultDestinationVisual;
};

export const getPortVisual = (label = 'Otro puerto') => {
  const normalized = (label || '').toLowerCase();
  const match = portRules.find((rule) => rule.match.test(normalized));
  return match || defaultPortVisual;
};
